import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import Rutas from './components/routes';

import 'bootstrap/dist/css/bootstrap.min.css'; // Importa la hoja de estilos de Bootstrap
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // Importa los archivos JavaScript de Bootstrap

import { registerLicense } from '@syncfusion/ej2-base';
registerLicense("Ngo9BigBOggjHTQxAR8/V1NHaF5cWWdCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWX1feXVSR2hZWUFxV0c=")

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render( 
    <Rutas /> 
);

reportWebVitals();
